export default __webpack_public_path__ + "static/media/GoodMannersOnThePlayground_13.118b8592.png";